export default __webpack_public_path__ + "static/media/foxy-bytes-mint.befa9daa.svg";